import { render, staticRenderFns } from "./MiniParser.vue?vue&type=template&id=2fc43f89&"
import script from "./MiniParser.vue?vue&type=script&lang=js&"
export * from "./MiniParser.vue?vue&type=script&lang=js&"
import style0 from "./MiniParser.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports